import { useMemo } from 'react';

interface MessageWithStatus {
  id: string;
  external_id?: string;
  delivered_at?: string | null;
  read_at?: string | null;
  status?: string;
  created_at: string;
}

export function useEmbeddedMessageStatus() {
  // Simple function to get status directly from message data
  const getMessageStatus = useMemo(() => {
    return (message: MessageWithStatus): 'sending' | 'sent' | 'delivered' | 'read' | 'failed' => {
      // If status is embedded in the message (from new DB function), use it
      if (message.status) {
        return message.status as 'sending' | 'sent' | 'delivered' | 'read' | 'failed';
      }
      
      // Fallback: calculate from timestamp columns
      if (message.read_at) {
        return 'read';
      }
      
      if (message.delivered_at) {
        return 'delivered';
      }
      
      if (message.external_id) {
        return 'sent';
      }
      
      // For new messages without WhatsApp ID, check age
      if (message.created_at) {
        const messageAge = Date.now() - new Date(message.created_at).getTime();
        // If message is older than 5 seconds, assume it was sent
        return messageAge > 5000 ? 'sent' : 'sending';
      }
      
      return 'sending';
    };
  }, []);

  return { getMessageStatus };
}